<template>
  <section v-if="Boolean(card.playerIndexId || card.otherIndexId)" class="card-profile-index">
    <h4 v-if="index" class="secondary-font">
      Index
    </h4>

    <div v-if="index" class="container" @click="openIndex">
      <index-list-item :index="index" />
    </div>
  </section>
</template>

<script>
import { indexService } from '@/services';

import IndexListItem from '@cardladder/shared/components/IndexListItem';

export default {
  components: {
    IndexListItem,
  },

  props: {
    card: Object,
  },

  data() {
    return {
      index: null,
    };
  },

  created() {
    this.load();
  },

  computed: {
    indexId() {
      return this.card?.playerIndexId || this.card?.otherIndexId;
    },
  },

  methods: {
    async load() {
      if (this.indexId) {
        try {
          this.index = await indexService.getIndex(this.card.playerIndexId ? 'players' : 'indexes', this.indexId);
        } catch (e) {
          // swallow
        }
      }
    },

    openIndex() {
      if (this.card?.playerIndexId) {
        this.$router.push(`/players/${this.card.playerIndexId}`);
      } else if (this.card?.otherIndexId) {
        this.$router.push(`/indexes/${this.card.otherIndexId}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-profile-index {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}

.index-list-item {
  padding: 0;
}

.container {
  cursor: pointer;
  padding: $gp;
  margin: 0 (-$gp);

  &:hover {
    background-color: var(--theme-highlight);
  }
}

h4 {
  margin-bottom: $gp * .25;
}

h5 {
  margin-bottom: 0;
}

.stats {
  margin-top: $gp * .5;
}
</style>
